<template>
  <basic-page title="Harjoitukset">
    <v-row class="fill-height">
      <v-col cols="12" lg="8" xl="8" offset-xl="2" offset-lg="2">
        <div class="d-flex justify-end" v-if="$isSuperAdmin">
          <v-switch
            v-model="editMode"
            label="Muokkaustila"
            inset
            class="mt-0"
          ></v-switch>
        </div>
        <v-row class="mb-5">
          <v-col cols="12" md="6" v-if="nextHarjoitus">
            <v-card>
              <v-list-item>
                <v-list-item-content>
                  <div class="text-overline mb-4">Harjoitukset</div>
                  <v-list-item-subtitle
                    :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
                    class="text-h6 mb-1 text-wrap"
                    >{{ nextHarjoitus.subject }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap"
                    ><span
                      >{{
                        $formatWeekDayDateAndHourMinute(nextHarjoitus.date)
                      }}
                      {{ formatType(nextHarjoitus.type) }},
                      {{ nextHarjoitus.location }},
                      {{ nextHarjoitus.info }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar>
                  <v-icon>mdi mdi-fireplace</v-icon>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" v-if="nextEvyHarjoitus">
            <v-card>
              <v-list-item>
                <v-list-item-content>
                  <div class="text-overline mb-4">Evy</div>
                  <v-list-item-subtitle
                    :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
                    class="text-h6 mb-1 text-wrap"
                    >{{ nextEvyHarjoitus.subject }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap"
                    ><span
                      >{{
                        $formatWeekDayDateAndHourMinute(nextEvyHarjoitus.date)
                      }}
                      {{ formatType(nextEvyHarjoitus.type) }},
                      {{ nextEvyHarjoitus.location }},
                      {{ nextEvyHarjoitus.info }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar>
                  <v-icon>mdi mdi-hospital-box</v-icon>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-progress-linear indeterminate v-if="loading" />
        <v-card class="mt-5">
          <v-card-title class="d-flex justify-space-between">
            Harjoitukset
            <div v-if="editMode">
              <v-btn
                color="primary"
                small
                class="mr-2"
                @click="
                  activeCollection = 'harjoitukset';
                  editedItem = { ...defaultItem };
                  editedIndex = -1;
                  dialog = true;
                "
                >Lisää uusi</v-btn
              >
              <v-btn
                color="secondary"
                small
                class="mr-2"
                @click="openImport('harjoitukset')"
                >Tuo Excelistä</v-btn
              >
              <v-btn
                color="error"
                small
                :disabled="selectedHarjoitukset.length === 0"
                @click="deleteSelected('harjoitukset')"
                >Poista valitut</v-btn
              >
            </div>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-data-table
              v-if="editMode"
              :headers="tableHeaders"
              :items="harjoitukset"
              :show-select="editMode"
              v-model="selectedHarjoitukset"
              item-key="id"
              disable-pagination
              hide-default-footer
              :item-class="
                (item) =>
                  nextHarjoitus && item.id === nextHarjoitus.id
                    ? 'blue lighten-5 font-weight-bold'
                    : ''
              "
            >
              <template v-slot:item.date="{ item }">
                <span :class="{ 'red--text': item.type === 'OT' }">
                  {{ $formatWeekDayDateAndHourMinute(item.date) }}
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="editItem(item, 'harjoitukset')"
                >
                  mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item, 'harjoitukset')">
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
            <harjoitukset-table
              v-else
              :harjoitukset="harjoitukset"
              :next-harjoitus="nextHarjoitus"
            />
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-title class="d-flex justify-space-between">
            Evy harjoitukset
            <div v-if="editMode">
              <v-btn
                color="primary"
                small
                class="mr-2"
                @click="
                  activeCollection = 'evyharjoitukset';
                  editedItem = { ...defaultItem };
                  editedIndex = -1;
                  dialog = true;
                "
                >Lisää uusi</v-btn
              >
              <v-btn
                color="secondary"
                small
                class="mr-2"
                @click="openImport('evyharjoitukset')"
                >Tuo Excelistä</v-btn
              >
              <v-btn
                color="error"
                small
                :disabled="selectedEvy.length === 0"
                @click="deleteSelected('evyharjoitukset')"
                >Poista valitut</v-btn
              >
            </div>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-data-table
              v-if="editMode"
              :headers="tableHeaders"
              :items="evyharjoitukset"
              :show-select="editMode"
              v-model="selectedEvy"
              item-key="id"
              disable-pagination
              hide-default-footer
              :item-class="
                (item) =>
                  nextEvyHarjoitus && item.id === nextEvyHarjoitus.id
                    ? 'blue lighten-5 font-weight-bold'
                    : ''
              "
            >
              <template v-slot:item.date="{ item }">
                <span :class="{ 'red--text': item.type === 'OT' }">
                  {{ $formatWeekDayDateAndHourMinute(item.date) }}
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="editItem(item, 'evyharjoitukset')"
                >
                  mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item, 'evyharjoitukset')">
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
            <harjoitukset-table
              v-else
              :harjoitukset="evyharjoitukset"
              :next-harjoitus="nextEvyHarjoitus"
              type="evy"
            />
          </v-card-text>
        </v-card>

        <!-- Edit Dialog -->
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.date"
                      label="Päivämäärä ja aika"
                      type="datetime-local"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="editedItem.subject"
                      label="Aihe"
                      auto-grow
                      rows="1"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="editedItem.type"
                      :items="['HT', 'OT', 'Muu']"
                      label="Tyyppi"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="editedItem.location"
                      label="Paikka"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="editedItem.info"
                      label="Lisätiedot"
                      rows="3"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Peruuta</v-btn>
              <v-btn color="blue darken-1" text @click="save">Tallenna</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Delete Dialog -->
        <v-dialog v-model="deleteDialog" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Haluatko varmasti poistaa tämän?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Peruuta</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Import Dialog -->
        <v-dialog v-model="importDialog" max-width="800px">
          <v-card>
            <v-card-title>Tuo Excelistä ({{ importType }})</v-card-title>
            <v-card-text>
              <p>
                Kopioi tiedot Excelistä ja liitä tähän. Oletettu järjestys:
                <strong>Pvm, Aihe, Tyyppi, Paikka, Lisätiedot</strong>.
                Sarakkeet erotettu sarkaimella (tab).
              </p>
              <v-textarea
                v-model="importText"
                label="Liitä tiedot tähän"
                rows="10"
                outlined
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="importDialog = false">Peruuta</v-btn>
              <v-btn color="primary" @click="importFromExcel">Tuo</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </basic-page>
</template>

<script>
import BasicPage from "@/components/BasicPage";
import dayjs from "dayjs";
import HarjoituksetTable from "@/components/HarjoituksetTable";
import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  writeBatch,
  Timestamp,
} from "firebase/firestore";
import { firestore as db } from "@/plugins/firebase.app";

export default {
  name: "Harjoitukset",
  components: { BasicPage, HarjoituksetTable },
  data: () => {
    return {
      loading: false,
      editMode: false,
      dialog: false,
      importDialog: false,
      deleteDialog: false,
      editedIndex: -1,
      editedItem: {
        date: "",
        subject: "",
        type: "HT",
        location: "Asema",
        info: "",
      },
      defaultItem: {
        date: "",
        subject: "",
        type: "HT",
        location: "Asema",
        info: "",
      },
      importText: "",
      importType: "harjoitukset", // 'harjoitukset' or 'evyharjoitukset'
      selectedHarjoitukset: [],
      selectedEvy: [],
      headers: [
        { text: "Pvm", value: "date" },
        { text: "Aihe", value: "subject" },
        { text: "Tyyppi", value: "type" },
        { text: "Paikka", value: "location" },
        { text: "Lisätiedot", value: "info" },
        { text: "Toiminnot", value: "actions", sortable: false },
      ],
      activeCollection: "harjoitukset", // Track which table we are editing
    };
  },
  computed: {
    today() {
      return dayjs().format("LLLL");
    },
    harjoitukset() {
      return this.$store.state.harjoitukset;
    },
    evyharjoitukset() {
      return this.$store.state.evyharjoitukset;
    },
    nextHarjoitus() {
      const today = dayjs();
      const nextHarjoitus = this.harjoitukset.find((h) =>
        dayjs(h.date).isAfter(today)
      );
      return nextHarjoitus;
    },
    nextEvyHarjoitus() {
      const today = dayjs();
      const nextEvyHarjoitus = this.evyharjoitukset.find((h) =>
        dayjs(h.date).isAfter(today)
      );
      return nextEvyHarjoitus;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Uusi harjoitus" : "Muokkaa harjoitusta";
    },
    tableHeaders() {
      if (this.editMode) {
        return this.headers;
      }
      return this.headers.filter((h) => h.value !== "actions");
    },
  },
  methods: {
    async reloadHarjoitukset() {
      this.loading = true;
      this.$store.commit("setHarjoitukset", []);
      this.$store.commit("setEvyHarjoitukset", []);
      try {
        await this.$store.dispatch("loadHarjoitukset");
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    async reloadAll() {
      await this.reloadHarjoitukset();
    },
    formatType(type) {
      return type === "OT" ? "Oppitunti" : type === "HT" ? "Harjoitus" : "";
    },

    // Admin Actions
    editItem(item, collectionName) {
      this.activeCollection = collectionName;
      this.editedIndex = this[collectionName].indexOf(item);
      // Format date for datetime-local input (YYYY-MM-DDTHH:mm)
      const date = dayjs(item.date).format("YYYY-MM-DDTHH:mm");
      this.editedItem = Object.assign({}, { ...item, date });
      this.dialog = true;
    },

    deleteItem(item, collectionName) {
      this.activeCollection = collectionName;
      this.editedItem = Object.assign({}, item);
      this.deleteDialog = true;
    },

    async deleteItemConfirm() {
      try {
        await deleteDoc(doc(db, this.activeCollection, this.editedItem.id));
        this.$toast.success("Poistettu onnistuneesti");
        this.reloadAll();
      } catch (e) {
        console.error(e);
        this.$toast.error("Virhe poistettaessa");
      }
      this.closeDelete();
    },

    closeDelete() {
      this.deleteDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      try {
        const data = {
          ...this.editedItem,
          date: dayjs(this.editedItem.date).toISOString(),
        };
        // Remove id from data if it exists
        const { id, ...saveData } = data;

        if (this.editedIndex > -1) {
          // Update
          await updateDoc(doc(db, this.activeCollection, id), saveData);
          this.$toast.success("Päivitetty onnistuneesti");
        } else {
          // Create
          await addDoc(collection(db, this.activeCollection), saveData);
          this.$toast.success("Luotu onnistuneesti");
        }
        this.reloadAll();
        this.close();
      } catch (e) {
        console.error(e);
        this.$toast.error("Virhe tallennettaessa");
      }
    },

    openImport(collectionName) {
      this.activeCollection = collectionName;
      this.importType = collectionName;
      this.importDialog = true;
    },

    async importFromExcel() {
      if (!this.importText) return;

      const rows = this.importText.trim().split("\n");
      const batch = writeBatch(db);
      let count = 0;

      try {
        rows.forEach((row) => {
          // Assume format: Date [tab] Subject [tab] Type [tab] Location [tab] Info
          // Date might need parsing logic depending on Excel format
          const cols = row.split("\t");
          if (cols.length >= 2) {
            // Basic validation
            const dateStr = cols[0].trim();
            // Try to parse date. Excel might copy as DD.MM.YYYY HH:mm or similar
            // Let's assume ISO or standard format for now, or try to parse Finnish format
            let date = dayjs(dateStr);
            if (!date.isValid()) {
              // Try custom parsing if needed, e.g. DD.MM.YYYY HH:mm
              const parts = dateStr.split(/[ .:]/);
              if (parts.length >= 5) {
                date = dayjs(
                  `${parts[2]}-${parts[1]}-${parts[0]}T${parts[3]}:${parts[4]}`
                );
              }
            }

            if (date.isValid()) {
              const docRef = doc(collection(db, this.activeCollection));
              batch.set(docRef, {
                date: date.toISOString(),
                subject: cols[1]?.trim() || "",
                type: cols[2]?.trim() || "HT",
                location: cols[3]?.trim() || "Asema",
                info: cols[4]?.trim() || "",
              });
              count++;
            }
          }
        });

        await batch.commit();
        this.$toast.success(`Tuotu ${count} riviä onnistuneesti`);
        this.reloadAll();
        this.importDialog = false;
        this.importText = "";
      } catch (e) {
        console.error(e);
        this.$toast.error("Virhe tuonnissa");
      }
    },

    async deleteSelected(collectionName) {
      const itemsToDelete =
        collectionName === "harjoitukset"
          ? this.selectedHarjoitukset
          : this.selectedEvy;

      console.log(
        `Attempting to delete ${itemsToDelete.length} items from ${collectionName}`
      );

      if (itemsToDelete.length === 0) return;

      if (!confirm(`Haluatko varmasti poistaa ${itemsToDelete.length} riviä?`))
        return;

      const batch = writeBatch(db);
      itemsToDelete.forEach((item) => {
        console.log(`Deleting doc: ${collectionName}/${item.id}`);
        const docRef = doc(db, collectionName, item.id);
        batch.delete(docRef);
      });

      try {
        await batch.commit();
        this.$toast.success("Valitut poistettu");
        if (collectionName === "harjoitukset") {
          this.selectedHarjoitukset = [];
        } else {
          this.selectedEvy = [];
        }
        await this.reloadAll();
      } catch (e) {
        console.error("Batch delete failed", e);
        this.$toast.error("Virhe poistettaessa: " + e.message);
      }
    },
  },
  mounted() {
    this.reloadAll();
  },
};
</script>

<style scoped lang="scss"></style>
